export const createSymbol = function (description) {
    return '@' + (description || '@') + Math.random();
};
//# sourceMappingURL=symbol.js.map